"use strict";
import React, {Component} from "react";
import {PropTypes, RenderContent} from "Subschema";

export default class Anchor extends Component {

    static displayName = 'Anchor';

    static template = false;

    static propTypes = {
        href: PropTypes.expression,
        content: PropTypes.content,
        className: PropTypes.string,
        linkClass: PropTypes.string,
        openInNewWindowUrl: PropTypes.string,
        newWindowWidth: PropTypes.number,
        newWindowHeight: PropTypes.number,
        newWindowTitle: PropTypes.string
    };

    static defaultProps = {
        target: "self"
    };

    constructOnClickCallback = () => {
      const {
        openInNewWindowUrl,
        newWindowWidth,
        newWindowHeight,
        newWindowTitle
      } = this.props;

      return !!openInNewWindowUrl ? {
        onClick: e => {
          e.preventDefault();
          window.open(openInNewWindowUrl, newWindowTitle || '',`width=${newWindowWidth || 500},height=${newWindowHeight || 400}, left=20, top=20`);
          return false;
        }
      } : {};
    }

    render() {
        const {
          content,
          className='',
          linkClass='',
          openInNewWindowUrl,
          newWindowWidth,
          newWindowHeight,
          newWindowTitle,
          ...rest
        } = this.props;

        const onClickCallBack = this.constructOnClickCallback();

        return (
          <a className={`${className} ${linkClass}`}
            {...rest}
            {...onClickCallBack}>
            { !content ? null : <RenderContent content={content}/> }
          </a>)
    }
}



/** WEBPACK FOOTER **
 ** ./src/types/anchor/Anchor.jsx
 **/